export default [
  {
    icon: 'mdi-file-document-outline',
    name: 'OpenBox',
    path: '/openbox',
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/openbox';
    },
    component: () => import(/* webpackChunkName: "openbox" */ '@/views/RouterViewComponent'),
    redirect: '/openbox/contable',
    id: 'openbox-toolbar',

    meta: {
      allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
      requiresAuth: true,
      toolbar: true,
      badge: true,
      badgeContent: 'unreadedUserDocuments',
      badgeChecker: 'userDocumentsReady',
      tooltip: null,
    },
    children: [
      {
        name: 'Área contable',
        icon: 'mdi-calculator',
        path: '/openbox/contable',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/openbox';
        },
        component: () => import(/* webpackChunkName: "openbox-upload" */ './views/OpenboxContable'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          toolbar: false,
          drawer: true,
          badge: true,
          badgeContent: 'unreadedUserContableDocuments',
          badgeChecker: 'userDocumentsReady',
          tooltip: null,
        },
      },
      {
        name: 'Área fiscal',
        icon: 'mdi-bank',
        path: '/openbox/fiscal',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/openbox';
        },
        component: () => import(/* webpackChunkName: "openbox-upload" */ './views/OpenboxFiscal'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          toolbar: false,
          drawer: true,
          badge: true,
          badgeContent: 'unreadedUserFiscalDocuments',
          badgeChecker: 'userDocumentsReady',
          tooltip: null,
        },
      },
      {
        name: 'Área Laboral',
        icon: 'mdi-briefcase-outline',
        path: '/openbox/laboral',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/openbox';
        },
        component: () => import(/* webpackChunkName: "openbox-upload" */ './views/OpenboxLaboral'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          toolbar: false,
          drawer: true,
          badge: true,
          badgeContent: 'unreadedUserLaboralDocuments',
          badgeChecker: 'userDocumentsReady',
          tooltip: null,
        },
      },
      {
        name: 'A contabilizar',
        icon: 'mdi-upload',
        path: '/openbox/upload',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/openbox';
        },
        component: () => import(/* webpackChunkName: "openbox-upload" */ './views/OpenboxUpload'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          toolbar: false,
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Todos mis documentos',
        icon: 'mdi-file-document-outline',
        path: '/openbox/documents',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/openbox';
        },
        component: () =>
          import(/* webpackChunkName: "openbox-documents" */ './views/OpenboxDocuments'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          toolbar: false,
          drawer: true,
          tooltip: null,
        },
      },
    ],
  },
];
